/**
 * Returns a list with auxiliaries for the Dutch passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default function() {
	return [
		"word",
		"wordt",
		"worden",
		"werd",
		"werden",
		"wordend",
	];
}
